import {useParams} from "react-router-dom";
import Feedbacks from "../../../Dashboard/Feedbacks";

const ReviewsTab = () => {

  const {id} = useParams();

    return (
        <>
          <Feedbacks productId={id}/>
        </>
    )
}

export default ReviewsTab;